/// <reference types="@angular/localize" />

import { licenseKey } from './licenses/devextreme-license';
import config from 'devextreme/core/config';

config({ licenseKey });

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
